import Vue from 'vue';
import WorkBaseTabs from '@/components/base_components/tabs/WorkBaseTabs';
import WorkTabsPicker from '@/components/global_components/tabs/WorkTabsPicker';
import WorkTabsTableContent from '@/components/global_components/tabs/WorkTabsTableContent';
import WorkDefaultTabIcon from '@/components/global_components/tabs/WorkDefaultTabIcon';

Vue.component('WTabs', WorkBaseTabs);
Vue.component('WTabsPicker', WorkTabsPicker);
Vue.component('WTabsTableContent', WorkTabsTableContent);
Vue.component('WDefaultTabIcon', WorkDefaultTabIcon);
